import { API } from 'aws-amplify';
import { Camera, serializer } from '../../models/camera';
import { Phase } from '@/models/phase';
import {
  CameraTikeeCreateRequest,
  CameraTikeeUpdateRequest,
  CameraUpdateRequest,
  CameraDeleteRequest,
} from './cameras.interfaces';
import { Shadow } from '../../models/shadow';

export class CameraService {
  public constructor(private readonly apiName: string) {}

  public async getMyCamera(): Promise<Camera[]> {
    return API.get(this.apiName, '/cameras/v2', {}).then((v: any) => {
      const cams = v?.cameras ?? [];

      console.log('[API raw] cameras len =', cams.length);

      const camWithTemp = cams.find((c: any) => Array.isArray(c?.temperatureLevels) && c.temperatureLevels.length > 0);

      const t0 = camWithTemp?.temperatureLevels?.[0];

      console.log('[API raw] first camWithTemp =', {
        id: camWithTemp?.id,
        tempLen: camWithTemp?.temperatureLevels?.length,
      });

      console.log('[API raw] temp sample object =', t0);
      console.log('[API raw] temp sample keys =', t0 ? Object.keys(t0) : []);

      // Optionnel: distribution des types de date sur un petit échantillon
      let nNum = 0,
        nStr = 0,
        nUndef = 0,
        nOther = 0;
      for (const c of cams.slice(0, 50)) {
        for (const t of (c?.temperatureLevels ?? []).slice(0, 10)) {
          const d = t?.date;
          if (d === undefined || d === null) nUndef++;
          else if (typeof d === 'number') nNum++;
          else if (typeof d === 'string') nStr++;
          else nOther++;
        }
      }
      console.log('[API raw] temp date types (sample) =', { nNum, nStr, nUndef, nOther });

      return serializer.parseAsArray(cams);
    });
  }

  public async createCameraTikee(cameraCreateRequest: CameraTikeeCreateRequest): Promise<Camera | undefined> {
    return API.post(this.apiName, '/cameras/tikee/new', {
      body: cameraCreateRequest,
    }).then((v) => serializer.parse(v));
  }

  public async updateCameraTikee(cameraUpdateRequest: CameraTikeeUpdateRequest): Promise<Camera | undefined> {
    return API.post(this.apiName, '/cameras/tikee/update', {
      body: cameraUpdateRequest,
    }).then((v) => serializer.parse(v));
  }

  public async importAllPhotoCameraTikee(cameraId: string): Promise<void> {
    return API.post(this.apiName, `/cameras/${cameraId}/import/tikee`, {});
  }

  public async updateCamera(cameraUpdateRequest: CameraUpdateRequest): Promise<Camera | undefined> {
    return API.post(this.apiName, '/cameras/update', {
      body: cameraUpdateRequest,
    }).then((v) => serializer.parse(v));
  }

  public async updateConfiguration(cameraUpdateConfigurationRequest: Shadow): Promise<Shadow> {
    return await API.post(this.apiName, '/cameras/update/configuration', {
      body: cameraUpdateConfigurationRequest,
    }).then((response) => {
      return response.state.desired as Shadow;
    });
  }

  public async deleteCamera(cameraDeleteRequest: CameraDeleteRequest): Promise<void> {
    return API.post(this.apiName, '/cameras/delete', {
      body: cameraDeleteRequest,
    });
  }

  public async createPhase(
    cameraId: string,
    payload: {
      name: string;
      date: Date;
      color?: string;
      start?: Date;
      end?: Date;
      lane?: string;
    }
  ): Promise<Camera | undefined> {
    return API.post(this.apiName, '/cameras/phases/create', {
      body: {
        cameraId,
        name: payload.name,
        date: payload.date.toISOString(),
        color: payload.color,
        start: payload.start ? payload.start.toISOString() : undefined,
        end: payload.end ? payload.end.toISOString() : undefined,
        lane: payload.lane,
      },
    }).then((v) => {
      if (!v) {
        console.error('Empty response from API');
        return undefined;
      }
      return serializer.parse(v);
    });
  }

  public async updatePhase(cameraId: string, phase: Phase): Promise<Camera | undefined> {
    return API.post(this.apiName, '/cameras/phases/update', {
      body: {
        cameraId,
        id: phase.id,
        name: phase.name,
        date: phase.date,
        color: phase.color,
        start: phase.start,
        end: phase.end,
        lane: phase.lane,
      },
    }).then((v) => serializer.parse(v));
  }

  public async deletePhase(cameraId: string, phaseId: string): Promise<Camera | undefined> {
    return API.post(this.apiName, '/cameras/phases/delete', {
      body: {
        cameraId,
        id: phaseId,
      },
    }).then((v) => serializer.parse(v));
  }

  public async requestVideoStream(cameraId: string): Promise<string> {
    return API.post(this.apiName, `/cameras/${cameraId}/livestream`, {});
  }

  public async takePicture(cameraId: string): Promise<string> {
    return API.post(this.apiName, `/cameras/${cameraId}/takePicture`, {});
  }

  public async Miroring(cameraId: string): Promise<string> {
    return API.post(this.apiName, `/cameras/${cameraId}/Miroring`, {});
  }

  public async reboot(cameraId: string, cameraName?: string): Promise<string> {
    return API.post(this.apiName, `/cameras/${cameraId}/reboot`, {
      body: { cameraName: cameraName ?? cameraId }, // par défaut, tu envoies l'id si pas de name
    });
  }

  public async rebootStatus(cameraId: string, cameraName: string): Promise<any> {
    return API.post(this.apiName, `/cameras/${cameraId}/status`, {
      body: { cameraName },
    });
  }

  public async getIrisCamVersion(cameraId: string, cameraName: string): Promise<any> {
    return API.post(this.apiName, `/cameras/${cameraId}/app/iriscam/version`, {
      body: { cameraName },
    });
  }

  public async updateIrisCam(
    cameraId: string,
    payload: {
      cameraName: string;
      appId: string;
      releaseLabelId?: string | null;
    }
  ): Promise<any> {
    return API.post(this.apiName, `/cameras/${cameraId}/app/iriscam/update`, { body: payload });
  }
}
